/**
 * @generated SignedSource<<6c495e0f5d1e2e6f36c5fd8fca3a58c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeliveryOrderDeliveryOrderHistoryPaginatorRefreshQuery$variables = {
  after?: string | null;
  first?: number | null;
  id: string;
};
export type DeliveryOrderDeliveryOrderHistoryPaginatorRefreshQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder">;
  };
};
export type DeliveryOrderDeliveryOrderHistoryPaginatorRefreshQuery = {
  response: DeliveryOrderDeliveryOrderHistoryPaginatorRefreshQuery$data;
  variables: DeliveryOrderDeliveryOrderHistoryPaginatorRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeliveryOrderDeliveryOrderHistoryPaginatorRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "FragmentSpread",
            "name": "DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeliveryOrderDeliveryOrderHistoryPaginatorRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeliveryOrderHistoryConnection",
                "kind": "LinkedField",
                "name": "histories",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DeliveryOrderHistoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DeliveryOrderHistory",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "picture",
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isDeleted",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "created",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "difference",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isDifference"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "description",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "address",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "addressDetail",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "zipCode",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "recipientName",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "recipientNumber",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "stuffTitle",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "title",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "DeliveryOrderDifference",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder_histories",
                "kind": "LinkedHandle",
                "name": "histories"
              }
            ],
            "type": "DeliveryOrder",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3225ff4997837dc18298399832cc3045",
    "id": null,
    "metadata": {},
    "name": "DeliveryOrderDeliveryOrderHistoryPaginatorRefreshQuery",
    "operationKind": "query",
    "text": "query DeliveryOrderDeliveryOrderHistoryPaginatorRefreshQuery(\n  $after: String\n  $first: Int = 10\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder_2HEEH6\n    id\n  }\n}\n\nfragment DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder_2HEEH6 on DeliveryOrder {\n  histories(first: $first, after: $after) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...DeliveryOrderHistoryDialog_deliveryOrderHistory\n        ...DeliveryOrderHistoryTimelineItem_deliveryOrderHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment DeliveryOrderDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on DeliveryOrderDifference {\n    description {\n      __typename\n    }\n    address {\n      __typename\n    }\n    addressDetail {\n      __typename\n    }\n    zipCode {\n      __typename\n    }\n    recipientName {\n      __typename\n    }\n    recipientNumber {\n      __typename\n    }\n    stuffTitle {\n      __typename\n    }\n    title {\n      __typename\n    }\n  }\n}\n\nfragment DeliveryOrderDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on DeliveryOrderDifference {\n    description {\n      ...DiffItem_diff\n    }\n    address {\n      ...DiffItem_diff\n    }\n    addressDetail {\n      ...DiffItem_diff\n    }\n    zipCode {\n      ...DiffItem_diff\n    }\n    recipientName {\n      ...DiffItem_diff\n    }\n    recipientNumber {\n      ...DiffItem_diff\n    }\n    stuffTitle {\n      ...DiffItem_diff\n    }\n    title {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment DeliveryOrderHistoryDialog_deliveryOrderHistory on DeliveryOrderHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...DeliveryOrderDifferenceCounterLabel_difference\n    ...DeliveryOrderDifferenceItemList_difference\n  }\n}\n\nfragment DeliveryOrderHistoryTimelineItem_deliveryOrderHistory on DeliveryOrderHistory {\n  id\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  created\n  type\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "1400a0072d8c6c4ff2c085ca503dfa25";

export default node;
